import script from "./FeaturedFixture.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedFixture.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedFixture.vue?vue&type=style&index=0&id=9fcaffd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fcaffd0"]])

export default __exports__